export default __webpack_public_path__ + "static/thirdMobile-e26ffe593bf01f651160b2a551c87800.jpg";